import type { ActiveTxState, TxType } from '@apm/contracts';
import type { ChipTone } from '../ui';

/**
 * 화면 공통 표기. 색·문구 판정은 컴포넌트 밖 순수 함수로 둔다(테스트 가능하게).
 *
 * 19회차에 시각·기간·숫자 표기는 `time.ts`로, 문구는 `terms.ts`로 옮겼다.
 * 여기 남은 것은 "경과가 길수록 뜨겁다"는 판정 하나뿐이다.
 */

/** 경과 시간 구간. 위로 갈수록 급하다 */
export type Tone = 'calm' | 'warm' | 'hot' | 'critical';

/**
 * 경과 시간에 따른 구간. 대상 앱 기준으로 잡았다.
 * 1초까지는 정상, 3초부터는 눈에 띄어야 하고, 10초를 넘으면 PDF(최대 30초) 말고는 사고다.
 */
export function elapsedTone(elapsedMs: number): Tone {
  if (elapsedMs >= 10_000) return 'critical';
  if (elapsedMs >= 3_000) return 'hot';
  if (elapsedMs >= 1_000) return 'warm';
  return 'calm';
}

/** 구간마다 붙는 글자. 색만으로 알리지 않는다 (콘솔 검토 D-3) */
export const TONE_LABEL: Record<Tone, string> = {
  calm: '',
  warm: '조금 느림',
  hot: '느림',
  critical: '아주 느림',
};

export const TONE_TEXT: Record<Tone, string> = {
  calm: 'text-ok',
  warm: 'text-muted',
  hot: 'text-fail',
  critical: 'text-error',
};

export const TONE_BAR: Record<Tone, string> = {
  calm: 'bg-ok',
  warm: 'bg-muted',
  hot: 'bg-fail',
  critical: 'bg-error',
};

/** 유형 칩 색. X-View 점 색(theme.ts TX_COLOR)과 같은 계열이다 */
export const TX_TYPE_TONE: Record<TxType, ChipTone> = {
  http: 'http',
  sse: 'sse',
  mcp: 'mcp',
  worker: 'worker',
  pdf: 'pdf',
  slow: 'slow',
};

/** 진행 중인 요청이 지금 하는 일. 문구는 `terms.ts`에 있다 */
export type { ActiveTxState };
